function initGnav() {
  const gnavBtn = document.querySelector('.js-gnav-btn');

  gnavBtn.addEventListener('click', e => {
    e.stopPropagation();
    document.body.classList.toggle('is-gnav-open');
  });

  document.addEventListener('click', () => {
    if (document.body.classList.contains('is-gnav-open')) {
      console.log('gnav open');
      document.body.classList.remove('is-gnav-open');
    }
  });
}

export default initGnav;